<template>
  <div>
    <v-dialog
      v-if="current"
      v-model="active"
      :hide-overlay="current.hideOverlay"
      :no-click-animation="current.noClickAnimation"
      :persistent="current.persistent"
      :retain-focus="current.retainFocus"
      :scrollable="current.scrollable"
      :light="current.light"
      :dark="current.dark"

      :fullscreen="current.fullscreen"

      :max-width="current.maxWidth"
      :width="current.width"
      :origin="current.origin"
      :transition="current.transition"

      :value="current.value"
    >
      <welcome-card
        v-if="currentIsWelcome"
        @close="onClose"
      />
      <business-only-card
        v-else-if="currentIsBusinessOnly"
        :current="current"
        @close="onClose"
      />
      <subscription-expired-card
        v-else-if="currentIsSubscriptionExpired"
        :current="current"
        @close="onClose"
      />
      <loader-card
        v-else-if="currentIsLoader"
        :current="current"
      />
      <confirm-card
        v-else-if="currentIsConfirm"
        :current="current"
        @cancel="onCancel"
        @confirm="onConfirm"
      />
      <alert-card
        v-else
        :current="current"
        @cancel="onCancel"
      />
    </v-dialog>
  </div>
</template>

<script>

  import {DIALOG_TYPES, dialogsEvents} from "../../../helpers/dialogs"
  import {isEmpty, isNull, isEqual} from "lodash/lang"
  import WelcomeCard from "./WelcomeCard"
  import BusinessOnlyCard from "./BusinessOnlyCard"
  import LoaderCard from "./LoaderCard"
  import ConfirmCard from "./ConfirmCard"
  import AlertCard from "./AlertCard"
  import SubscriptionExpiredCard from "./SubscriptionExpiredCard"

  export default {
    name: "Dialogs",
    components: {SubscriptionExpiredCard, AlertCard, ConfirmCard, LoaderCard, BusinessOnlyCard, WelcomeCard},
    data() {
      return {
        dialogs: [],
        current: null,
        active: false,
      }
    },
    methods: {
      addDialog(event) {
        this.dialogs.push(event)

        if (isNull(this.current)) {
          this.current = this.dialogs.pop()
          this.active = true

          if (isEqual(this.current.type, DIALOG_TYPES.LOADER)) {
            setTimeout(function () {
              this.current.loaderPromise.finally(() => {
                this.onClose()
              })
            }.bind(this), 500)
          }
        }
      },
      onClose() {
        this.active = false
        this.current = null

        if (isEmpty(this.dialogs))
          return

        setTimeout(() => {
          this.current = this.dialogs.shift()
          this.active = true
        }, 500)
      },
      onConfirm() {
        this.current.onConfirm()
        this.active = false
      },
      onCancel() {
        this.current.onCancel()
        this.active = false
      },
    },
    mounted() {
      dialogsEvents.$on("add-dialog", this.addDialog)
    },
    computed: {
      currentIsConfirm() {
        return this.current ? isEqual(this.current.type, DIALOG_TYPES.CONFIRM) : false
      },
      currentIsLoader() {
        return this.current ? isEqual(this.current.type, DIALOG_TYPES.LOADER) : false
      },
      currentIsWelcome() {
        return this.current ? isEqual(this.current.type, DIALOG_TYPES.WELCOME) : false
      },
      currentIsBusinessOnly() {
        return this.current ? isEqual(this.current.type, DIALOG_TYPES.BUSINESS_ONLY) : false
      },
      currentIsSubscriptionExpired() {
        return this.current ? isEqual(this.current.type, DIALOG_TYPES.SUBSCRIPTION_EXPIRED) : false
      },
    },
    watch: {
      active(newValue) {
        if (!newValue) {
          this.onClose()
        }
      },
    },
  }
</script>

<style scoped lang="scss">
</style>
